import type { FooterBadge } from './types';

/** Optional badges shown until an admin saves a badge list. */
export const DEFAULT_FOOTER_BADGES: FooterBadge[] = [];
